module.exports = __webpack_public_path__ + "img/app_logo.d9709e8f.png";